import * as React from "react";

const GlobeIcon = ({ width = 20, height = 20, color = "black", ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 5.12 5.12"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g strokeWidth={0} />
    <g strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M5.125 2.56A2.565 2.565 0 0 0 2.713.005L2.629 0l-.025.001L2.559 0C1.146 0-.005 1.148-.005 2.56S1.146 5.12 2.56 5.12l.045-.001.025.001q.042 0 .084-.005A2.566 2.566 0 0 0 5.126 2.56m-.477.824a4.4 4.4 0 0 0-.7-.127 5 5 0 0 0 .018-1.252c.495-.059.712-.134.726-.139l-.06-.168a2.2 2.2 0 0 1 .173.863c0 .291-.056.569-.158.824M1.427 2.56q.001-.269.034-.522c.259.02.57.036.934.039v1.11a14 14 0 0 0-.914.038 4 4 0 0 1-.054-.665M2.714.341c.392.114.728.658.879 1.38-.242.019-.533.034-.879.037zm-.319.004v1.413a13 13 0 0 1-.88-.036c.154-.713.492-1.254.88-1.377m0 3.161v1.269c-.362-.115-.681-.593-.847-1.235a14 14 0 0 1 .847-.034m.319 1.273V3.507q.493.006.846.035c-.163.651-.48 1.132-.846 1.238m0-1.592v-1.11a13 13 0 0 0 .931-.04 4.2 4.2 0 0 1-.02 1.188 13 13 0 0 0-.911-.038m1.86-1.618c-.048.015-.25.072-.655.12-.09-.48-.253-.89-.465-1.186A2.26 2.26 0 0 1 4.575 1.57zM1.794.453c-.261.3-.474.731-.59 1.241a6 6 0 0 1-.666-.106A2.26 2.26 0 0 1 1.795.454zM.418 1.886c.062.017.294.075.728.122a4 4 0 0 0 .023 1.245 6 6 0 0 0-.703.113 2.2 2.2 0 0 1-.151-.806q.001-.353.104-.674zm.187 1.776c.116-.025.325-.062.633-.094.122.448.319.828.556 1.1A2.26 2.26 0 0 1 .605 3.663zm2.848.954c.191-.266.342-.625.436-1.044.317.036.516.079.616.104a2.26 2.26 0 0 1-1.053.94"
      fill={color}
    />
  </svg>
);

export default GlobeIcon;
